<template>
  <div>
    <div class="article-frame">
      <div class="article-box article-box-bg">
        <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/pc_banner_sup_responsible.webp`)">
        <div class="content pos-relative">
          <go-to-top />
          <sup-menu />

          <h1 class="main-title">
            自己規制
          </h1>

          <h2 class="subheading fs_6 text-body">
            ギャンブルをコントロールすることが困難であると感じる場合は、 1日間・7日間・30日間の自己規制を設定することができます。
          </h2>

          <h2 class="subheading fs_6 text-body">
            有効にすると、この期間中のこのアカウントのログインは制限されます。
          </h2>

          <h2 class="subheading fs_6 mb-5">
            <router-link class="href-link" to="/page/sup-responsible-gaming">
              責任あるギャンブル
            </router-link>
          </h2>
          <h2 class="subheading fs_6 mb-0 sub-pt-5">
            自己規制をご希望の期間を選択ください。
          </h2>
          <div class="sup-frorm-restraint">
            <select v-model="selectedDay" class="sup-frorm-select mx-auto ">
              <option value="1">
                1日間
              </option>
              <option value="7">
                7日間
              </option>
              <option value="14">
                14日間
              </option>
              <option value="30">
                30日間
              </option>
            </select>
            <button class="btn btn-style-primary" @click="isLogin">
              確認
            </button>
          </div>
        </div>
      <!-- content End -->
      </div>
    </div>
    <div v-if="showModal" class="popup-frame popup-self-restraint" :class="{'active': showModal}">
      <div class="popup-container popup-dialog popup-dialog-centered popup-dialog-scrollable justify-content-center">
        <div class="popup-package pop-card-edit">
          <button class="btn-close" href="#" @click="showModal=false" />
          <div class="popup-content">
            <div class="popup-header" />
            <div class="popup-body">
              <p class="text-center">
                有効にすると、この期間中のこのアカ<br>ウントのログインは制限されます
              </p>
              <div class="credit-edit-frame">
                <button id="close" type="button" class="btn btn-secondary btn-style-outline-secondary" @click="logout">
                  確認
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
import { logout as localLogout } from '@/utils/user'
import { selfLimitLogin } from '@/api/user'
import { showNotice } from '@/utils/tool'

export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      showModal: false,
      selectedDay: 1
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    isLogin() {
      if (this.$store.getters.token) {
        this.showModal = true
      } else {
        localStorage.setItem('fromSelfRestraint', true)
        this.$router.push('/')
      }
    },
    logout() {
      this.showModal = false

      let timestamp = Math.floor(Date.now() / 1000)
      const days = parseInt(this.selectedDay, 10) || 1
      timestamp += 86400 * days

      selfLimitLogin({ login: timestamp }).then(res => {
        if (res.data.data.code === 0) {
          localLogout()
        } else {
          showNotice(res.data.data.message)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
.popup-body .btn-style-outline-secondary{
	color: #B1A781;
	border: 1px solid #B1A781;
	background-color: transparent;
}

.popup-body .btn-style-outline-secondary:hover,
.popup-body .btn-style-outline-secondary:focus {
	color: #FFF;
	border: 1px solid #B1A781;
	background-color: #B1A781;
}
</style>
